export const CHAT_DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

const CHAT_DRAFT_STORAGE_PREFIX = "vaultgrid:chat-draft:v1:";
const CHAT_DRAFT_MAX_LENGTH = 20_000;

function getLocalStorage() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage || null;
  } catch {
    return null;
  }
}

export function buildChatDraftStorageKey(userId, chatIdentity) {
  const normalizedUserId = String(userId ?? "").trim();
  const normalizedChatIdentity = String(chatIdentity ?? "").trim();
  if (!normalizedUserId || !normalizedChatIdentity) return null;

  return `${CHAT_DRAFT_STORAGE_PREFIX}${encodeURIComponent(normalizedUserId)}:${encodeURIComponent(
    normalizedChatIdentity
  )}`;
}

export function removeChatDraft(storageKey) {
  if (!storageKey) return;
  try {
    getLocalStorage()?.removeItem(storageKey);
  } catch {
    // Draft persistence is best-effort and must never break the composer.
  }
}

export function loadChatDraft(storageKey, now = Date.now()) {
  if (!storageKey) return "";

  try {
    const raw = getLocalStorage()?.getItem(storageKey);
    if (!raw) return "";

    const parsed = JSON.parse(raw);
    const updatedAt = Number(parsed?.updatedAt || 0);
    const text = typeof parsed?.text === "string" ? parsed.text : "";
    const expired = !updatedAt || now - updatedAt > CHAT_DRAFT_TTL_MS;

    if (!text || expired) {
      removeChatDraft(storageKey);
      return "";
    }

    return text;
  } catch {
    removeChatDraft(storageKey);
    return "";
  }
}

export function saveChatDraft(storageKey, value, now = Date.now()) {
  if (!storageKey) return;

  const text = String(value ?? "").slice(0, CHAT_DRAFT_MAX_LENGTH);
  if (!text) {
    removeChatDraft(storageKey);
    return;
  }

  try {
    getLocalStorage()?.setItem(
      storageKey,
      JSON.stringify({
        text,
        updatedAt: now,
      })
    );
  } catch {
    // Storage can be unavailable or full. The in-memory composer still works.
  }
}
